import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, of } from 'rxjs';
import { catchError, mergeMap, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { LoadConfigService } from 'src/app/services/load-config.service';
import { AppState } from '../app.state';
import { loadConfig, loadConfigError, loadConfigSuccess } from './config.actions';
//import { MediaLoaderService } from 'src/app/services/media-loader.service';
import { ConfigApiService } from 'src/app/services/config-api.service';
import { InstructionService } from 'src/app/services/instruction.service';
import { StudyNavigationService } from 'src/app/services/study-navigation.service';
import { enablePage } from '../app-meta/app-meta.actions';
import { selectConfig } from './config.selectors';

@Injectable()
export class ConfigEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private loadConfigService: LoadConfigService,
    //private mediaLoaderService: MediaLoaderService,
    private instructionService: InstructionService,
    private studyNavigationService: StudyNavigationService,
    private configApiService: ConfigApiService
  ) {}

  test$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadConfig),
      withLatestFrom(this.store.select(selectConfig)),
      take(1),
      mergeMap(([_, configStatus]) =>
        from(this.orchestrateConfigDistribution(configStatus)).pipe(
          switchMap(() => {
            return of(loadConfigSuccess());
          }),
          catchError(err => {
            console.error(err);
            this.store.dispatch(
              enablePage({
                disablePage: true,
                stopLoadingSpinner: true,
                noConfigData: true
              })
            );
            return of(loadConfigError({ error: err.message }));
          })
        )
      )
    )
  );

  private async orchestrateConfigDistribution(configStatus) {
    this.loadConfigService.setUserID(this.configApiService.getParams().user);
    this.loadConfigService.setClientConfig(configStatus.config['client_config']);
    this.loadConfigService.setConfig(configStatus.config['config']);
    // Comment out for now (Media files)
    // Comment out mediaService for now as it not used
    //this.mediaLoaderService.setMediaFiles(configStatus.config['media']);
    this.instructionService.setInstructions(configStatus.config['instructions']);
    this.instructionService.setTranslations(configStatus.config['translations']);
    // Tobi: does not work with mock-up data - try with real config

    // Comment this out as it is not needed for now
    //await this.mediaLoaderService.initLookupTable();

    // Tobi: does not work with mock-up data - try with real configs
    //this.studyNavigationService.initNavigationSubject();
    this.studyNavigationService.init();

    this.store.dispatch(
      enablePage({
        disablePage: false,
        stopLoadingSpinner: false,
        noConfigData: false
      })
    );
  }
}
